import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import jwt_decode from "jwt-decode";
import { serverURL } from '../config/urls';
import "../styles/auth-forms.css"
import { logEvent } from '@firebase/analytics';
import {analytics} from '../config/firebase-logging';
import { useCareerContext } from './career-context';

function SignUp() {
    const { handleError } = useCareerContext();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    function handleSignUp(e) {
        setIsLoading(true);
        e.preventDefault();
        const emailIsValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target[2].value);
        const doPasswordsMatch = e.target[3].value === e.target[4].value;
        const passwordMeetsRequirements = e.target[3].value.length >= 8;
        const termsAndConditionsAgreedTo = e.target[5].checked;
        if (!emailIsValid) {
            handleError("Please enter a valid email address");
            setIsLoading(false);
        } else if (!doPasswordsMatch) {
            handleError("Passwords do not match");
            setIsLoading(false);
        } else if (!passwordMeetsRequirements) {
            handleError("Password must be at least 8 characters long");
            setIsLoading(false);
        } else if (!termsAndConditionsAgreedTo) {
            handleError("You must agree to the terms and conditions");
            setIsLoading(false);
        } else {
            fetch(serverURL + "/register",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ 
                        firstName: e.target[0].value,
                        lastName: e.target[1].value,
                        email: e.target[2].value.toLowerCase(), 
                        password: e.target[3].value 
                    })
                })
                .then(response => response.json())
                .then(data => {
                    const { error, message } = data;
                    if (error) {
                        handleError(message);
                    } else {
                        if (process.env.REACT_APP_ENVIRONMENT === "production") {
                            logEvent(analytics, 'register')
                        }
                        localStorage.setItem('token', data.token)
                        navigate("/");
                        window.location.reload();
                    }
                    setIsLoading(false);
                })
                .catch(err => {
                    handleError("An unknown error occurred")
                    if (process.env.REACT_APP_ENVIRONMENT === "production") {
                        logEvent(analytics, 'error', { error_message: "register_error: " + err.message })
                    }
                    setIsLoading(false);
                })
        }
    }

    return (
        <div className='auth container col' style={{ textAlign: "center" }}>
            <h1>Sign up for an account</h1>
            <div className='form-wrapper col'>
                <form className='col' onSubmit={handleSignUp}>
                    <div className='form-group row' style={{ justifyContent: "space-between" }}>
                        <div className='col' style={{ width: "46%" }} >
                            <label>First Name <span className='red'>*</span></label>
                            <input type='text' required />
                        </div>
                        <div className='col' style={{ width: "46%" }} >
                            <label>Last Name <span className='red'>*</span></label>
                            <input type='text' required />
                        </div>
                    </div>
                    <div className='form-group col'>
                        <label>Email <span className='red'>*</span></label>
                        <input type='text' required />
                    </div>
                    <div className='form-group col'>
                        <label>Password <span className='red'>*</span></label>
                        <input type='password' required />
                    </div>
                    <div className='form-group col'>
                        <label>Confirm Password <span className='red'>*</span></label>
                        <input type='password' required />
                    </div>
                    <div className='form-group row' style={{ justifyContent: 'space-between' }}>
                        <div className='row' style={{ gap: "5px" }}>
                            <input type='checkbox' />
                            <label>I agree to the <a className='green' href="/terms-and-conditions">terms and conditions</a></label>
                        </div>
                    </div>
                    <button style={{backgroundColor: isLoading ? "#89cf89" : "#42b342", cursor: isLoading ? "not-allowed" : "pointer"}} disabled={isLoading}>Sign Up</button>
                </form>
                <p style={{ margin: "15px 0px" }}>Or</p>
                <GoogleLogin
                    width="350px"
                    size="large"
                    theme="filled_blue"
                    onSuccess={credentialResponse => {
                        const data = jwt_decode(credentialResponse.credential);
                        fetch(serverURL + "/auth/google", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ email: data.email, firstName: data.given_name, lastName: data.family_name })
                        })
                            .then(response => response.json())
                            .then(data => {
                                const { error, message } = data;
                                if (error) {
                                    handleError(message);
                                } else {
                                    if (process.env.REACT_APP_ENVIRONMENT === "production") { 
                                        logEvent(analytics, 'register') 
                                    }
                                    localStorage.setItem('token', data.token)
                                    navigate("/");
                                    window.location.reload();
                                }
                            })
                            .catch(err => {
                                handleError("An unknown error occurred")
                                if (process.env.REACT_APP_ENVIRONMENT === "production") {
                                    logEvent(analytics, 'error', { error_message: "register_error: " + err.message })
                                }
                            })
                    }}
                    onError={() => {
                        handleError("Login failed")
                    }}
                />
                
            </div>

        </div>

    );
}

export default SignUp;